import { ArrowDownIcon, ArrowUpIcon, TrashIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { SaveChanges } from 'components/SaveChanges'
import { InputType } from 'config'
import { accountTypes } from 'config/user.type.constants'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getAdminConfig, setAdminConfig } from 'services'
import { Button } from 'stories/components'
import { confirm } from 'utils'
import { RenderInput } from 'utils/RenderInput'

export const LoanSubmissionHierarchy = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<Array<Array<string>>>([])
  const [changed, setChanged] = useState(false)

  const initData = async () => {
    setLoading(true)
    const data = await getAdminConfig('loanSubmissionHierarchy')
    setData(data)
    setLoading(false)
  }
  useEffect(() => {
    initData()
  }, [])

  const onChange = (id: number, value: any) => {
    const temp = cloneDeep(data)
    data.map((item, index: number) => {
      if (index === id) return
      temp[index] = item.filter((v) => !value.includes(v))
    })
    temp[id] = value
    setData(temp)
    setChanged(true)
  }

  const onAdd = () => {
    const temp = cloneDeep(data)
    temp.push([])
    setData(temp)
    setChanged(true)
  }

  const onDelete = async (index: number) => {
    const isContinue = await confirm('Are you sure you want to delete this level?')
    if (!isContinue) return

    const temp = cloneDeep(data)
    temp.splice(index, 1)
    setData(temp)
    setChanged(true)
  }

  const reorder = (index: number, dir: number) => {
    const temp = cloneDeep(data)
    if (index + dir < 0 || index + dir > temp.length) return

    let tempArr = []
    tempArr = temp[index]
    temp[index] = temp[index + dir]
    temp[index + dir] = tempArr
    setData(temp)
    setChanged(true)
  }

  const onSubmit = async () => {
    setLoading(true)
    await setAdminConfig('loanSubmissionHierarchy', data)
    toast('Successfully submitted', { type: 'success' })
    setLoading(false)
    setChanged(false)
  }

  return (
    <div className="relative px-3 py-1.5">
      <LayoutLoading show={loading} />

      <div className="text-xl font-bold mb-4">Loan Submission Hierarchy</div>
      {data.map((item, index: number) => {
        const input: InputType = {
          inputType: 'multiselect',
          title: 'Account Types',
          options: accountTypes,
          sort: true,
          defaultSelected: false,
          value: data[index],
        }

        input.additionalElements = (
          <div className="flex gap-2">
            <span className="text-shade-blue cursor-pointer" onClick={() => reorder(index, -1)}>
              <ArrowUpIcon className="w-4 h-4" />
            </span>
            <span className="text-shade-blue cursor-pointer" onClick={() => reorder(index, 1)}>
              <ArrowDownIcon className="w-4 h-4" />
            </span>
            <span className="text-red-500 cursor-pointer" onClick={() => onDelete(index)}>
              <TrashIcon className="w-4 h-4" />
            </span>
          </div>
        )
        return (
          <div className="w-full flex gap-2 items-center my-2">
            <span>{index + 1}.</span>
            <div className="w-full">
              <RenderInput
                input={input}
                Key={`accountType-${index}`}
                onChange={(key: string, value: any) => onChange(index, value)}
              />
            </div>
          </div>
        )
      })}
      <span className="text-shade-blue cursor-pointer hover:underline" onClick={onAdd}>
        + Add New
      </span>

      <div>
        {data.map((item, index: number) => {
          const filteredItems = item.filter((v) => !!accountTypes[v])
          return (
            <>
              {index ? <div className="w-[50%] border-r border-black h-[30px]"></div> : null}
              <div className="flex justify-center flex-wrap">
                {filteredItems.map((v, subInd: number) => {
                  return (
                    <div>
                      {index && filteredItems.length > 1 ? (
                        <div className="flex w-full">
                          <div className={`${subInd ? 'border-t' : ''} border-black w-[50%] h-[10px]`}></div>
                          <div
                            className={`${
                              subInd !== filteredItems.length - 1 ? 'border-t' : ''
                            } border-l border-black w-[50%] h-[10px]`}
                          ></div>
                        </div>
                      ) : (
                        ''
                      )}
                      <div className="px-1 py-1">
                        <div className="border border-gray-400 rounded-md px-2 py-1">{accountTypes[v]}</div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </>
          )
        })}
      </div>

      <div className="flex justify-center mt-4">
        <Button onClick={onSubmit} loading={loading}>
          Submit
        </Button>
      </div>
      <SaveChanges show={changed} label="Save Changes" onSave={onSubmit} />
    </div>
  )
}
